import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Cookie from "cookie-universal";
import { baseURL } from "../../Api/Api";
import { getToken, setSession, clearSession } from "../../session";
const cookie = Cookie();


export const loginAction = createAsyncThunk(
  "auth/login",
  async ({ values }, { rejectWithValue, getState }) => {
    try {
    
      const body = {username:values.email , password:values.password}
      
      const response = await axios.post(
        `${baseURL}/category-login`,

        body,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = response.data;
      if (data.error) {
        return rejectWithValue(data);
      }
      return data;
    } catch (error) {
      if (error?.response?.data?.error) {
        return rejectWithValue({
          message: error?.response?.data?.error,
        });
      } else if (error?.response?.data?.message) {
        return rejectWithValue({
          message: error?.response?.data?.message,
        });
      }else if (error?.response?.data?.errors?.password) {
        return rejectWithValue({
          message: error?.response?.data?.errors?.password,
        });
      }
    }
  }
);


const initialState= {
  loading: false,
  error:null ,
  token: getToken(),
  data: cookie.get('categoryData') ? cookie.get('categoryData'): null
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    reset(state) {
      state.loading = false;
      state.error = null;
    },
    removeToken(state) {
      clearSession();
      cookie.remove('categoryData');
      state.token = null;
      state.data = null;
    },
    updateUserCoins(state, action) {
      if (state.data) {
        const newCoins = action.payload;
        state.data = { ...state.data, coins: newCoins };
        // Update cookie with new data
        cookie.set('categoryData', state.data);
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loginAction.pending, (state, action) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(loginAction.fulfilled, (state, action) => {
      setSession(action?.payload?.token);
      cookie.set('categoryData' , action?.payload.category)
      state.loading = false;
      state.token = action.payload?.token
      state.data = action.payload?.category;
      state.error = null;
    });
    builder.addCase(loginAction.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.message;
    });
  },
});

export const { reset, removeToken, updateUserCoins } = authSlice.actions;
const authReducer = authSlice.reducer;

export default authReducer;
